import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		body: {
			display: "flex",
			flexDirection: "column",
			// Figma separates the paragraphs with a blank Body1 line.
			gap: theme.spacing(3),
			"& p": {
				fontSize: 18,
				lineHeight: "24px",
				color: theme.palette.custom.textPrimary,
			},
		},
	} satisfies Record<string, CSSObject>);
};
